(function ($, root, undefined) {

  $(function () {

      'use strict';

    // Fonction fixe navigation

    // fixeNav();

    // function fixeNav() {
    //   var header = $("html");
    //   $(window).scroll(function() {
    //       var scroll = $(window).scrollTop();
    //       if (!$('.page-template').hasClass('home')) {
    //         if (scroll >= 10) {
    //             header.addClass("navfixed");
    //         } else {
    //             header.removeClass("navfixed");
    //         }
    //       }
    //   });
    // }

    jQuery.expr[':'].regex = function(elem, index, match) {
        var matchParams = match[3].split(','),
            validLabels = /^(data|css):/,
            attr = {
                method: matchParams[0].match(validLabels) ?
                            matchParams[0].split(':')[0] : 'attr',
                property: matchParams.shift().replace(validLabels,'')
            },
            regexFlags = 'ig',
            regex = new RegExp(matchParams.join('').replace(/^\s+|\s+$/g,''), regexFlags);
        return regex.test(jQuery(elem)[attr.method](attr.property));
    }

    var postTypes = [
      'post-type-vins'
      , 'post-type-aperitifs'
      , 'post-type-eauxsodas'
      , 'post-type-jusdefruits'
      , 'post-type-bieres'
      , 'post-type-cafesetthes'
      , 'post-type-digestifs'
    ]

    if($('.wp-admin:regex(class,('+postTypes.join('|')+'))').length){
      if(!$('#domaine').length || $('#domaine').val() !== ""){
        $('.wp-list-table.posts').addClass('draggable');
        $('.wp-list-table.posts #the-list').sortable({
          handle: ".column-order",
          update: function( event, ui ) {
            var posts = [];
            $(this).find('tr[id^="post"]').each(function(index, post){
              posts.push($(post).attr('id').split('-')[1]);
            });
            $.post(
              wpadmin.ajax_url,
              {
                action: "ordering_post",
                posts: posts
              }
            )
            .fail(function(errors){
              console.error(errors);
            });
          }
        });
      }
    }

  });

})(jQuery, this);
